import { render, staticRenderFns } from "./Ehs.vue?vue&type=template&id=71562d3e&scoped=true&"
import script from "./Ehs.vue?vue&type=script&lang=js&"
export * from "./Ehs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71562d3e",
  null
  
)

export default component.exports